import Web3 from 'web3';
import showOverlay from '../showOverlay';
import getContract from "../getContract";
import getNfsgContract from "../getNfsgContract";
import getNfsgxContract from "../getNfsgxContract";
import login from '../checkLogin';

const checkMetamask = async function () {
  let options = null;
  if (window.ethereum) {
    options = await new Web3(ethereum);

    try {
      await ethereum.request({ method: 'eth_requestAccounts' });
      console.log('checkMetamask: true');
    } catch (err) {
      showOverlay(`Wrong network. Please change your network to ${window.chainName}`, false);
      return false;
    }
  } else {
    showOverlay('Please install Metamask. <a href="https://metamask.io/download.html" target="_blank" style="color: #ff0052;">https://metamask.io/download.html</a>', false);
    return false;
  }

  if (options) {
    window.selectedChain = options.eth.net.currentProvider.chainId === window.chainId ? 'AVAX' : (options.eth.net.currentProvider.chainId === window.chainIdChz ? 'CHZ' : false);

    if (options.eth.net.currentProvider.chainId !== window.chainId
      && (window.chainIdChz === '0'
        || (window.chainIdChz !== '0' && options.eth.net.currentProvider.chainId !== window.chainIdChz))) {
      showOverlay(
        `<br> Wrong network. <br><br> Please choose an available networks; <a href="#" class="btn-link js-network-check" data-chain-id="${window.chainId}" target="_blank">${window.chainName}</a>${window.chainIdChz !== '0' ? ` or <a href="#" class="btn-link js-network-check" data-chain-id="${window.chainIdChz}" target="_blank">${window.chainNameChz}</a>` : ''}.`, false,
      );
      return false;
    }
  }

  window.ethereum.on('chainChanged', () => {
    window.selectedChain = options.eth.net.currentProvider.chainId === window.chainId ? 'AVAX' : (options.eth.net.currentProvider.chainId === window.chainIdChz ? 'CHZ' : false);
    window.contract = false;
    getContract();
    window.nfsgContract = false;
    getNfsgContract();
    window.nfsgxContract = false;
    getNfsgxContract();
    window.location.reload();
  });

  window.ethereum.on('accountsChanged', () => {
    login();
  });

  // if (isMobile()) {
  //     showOverlay('You can use metamask mobile app for minting', false);
  // }
  window.web3 = options;
  window.web3Client = options;
  return true;
};

export default checkMetamask;
